import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import ProductButtons from './ProductButtons';
import ProductInfo from './ProductInfo';

const RepresentativeCase = ({ product }) => {
    const { kreditbetrag, rate, laufzeit, sollzins, fixlaufzeit, effzins, rueckges, zinsges, institut, description } = product;


      const formatEuroNumber = (value) => {
        return value.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      };

  return (
        <div class="card mb-4">
        <div class="card-body">
        <div className="row align-items-center text-center">
        <h3>Repräsentatives Rechenbeispiel</h3>
            <div className="row text-center">
                <hr style={{width: "500px", margin: "auto", marginBottom: "20px", paddingRight: "120px"}} />
            </div>
            <div className="row">
                <div className="col" style={{textAlign: "right"}}>
                    <p>
                    <strong>Gesamtkreditbetrag</strong>
                    </p>
                </div>
                <div className="col" style={{textAlign: "left"}}>
                    <p>
                    <small>{formatEuroNumber(kreditbetrag)} €</small>
                    </p>
                </div>
            </div>
            <div className="row">
                <div className="col" style={{textAlign: "right"}}>
                    <p>
                    <strong>Monatliche Rate</strong>
                    </p>
                </div>
                <div className="col" style={{textAlign: "left"}}>
                    <p>
                    <small>{formatEuroNumber(rate)} €</small>
                    </p>
                </div>
            </div>
            <div className="row">
                <div className="col" style={{textAlign: "right"}}>
                    <p>
                    <strong>Kreditlaufzeit</strong>
                </p>
            </div>
            <div className="col" style={{textAlign: "left"}}>
                <p>
                    <small>{laufzeit} Monate</small>
                    </p>

                </div>
            </div>
            <div className="row">
                <div className="col" style={{textAlign: "right"}}>
                    <p>
                      <strong>Nominalzinssatz</strong>
                  </p>
              </div>
              <div className="col" style={{textAlign: "left"}}>
                  <p>
                      <small>{sollzins.toFixed(3)}% p.a.</small>
                    </p>
                </div>
            </div>
            <div className="row">
                <div className="col" style={{textAlign: "right"}}>
                    <p>
                      <strong>Effektivzinssatz</strong>
                  </p>
              </div>
              <div className="col" style={{textAlign: "left"}}>
                  <p>
                      <small>{effzins.toFixed(3)}% p.a.</small>
                    </p>
                </div>
            </div>
            <div className="row">
                <div className="col" style={{textAlign: "right"}}>
                    <p>
                      <strong>Zinsen und Gebühren gesamt</strong>
                  </p>
              </div>
              <div className="col" style={{textAlign: "left"}}>
                  <p>
                      <small>{formatEuroNumber(zinsges)} €</small>
                    </p>
                </div>
            </div>
            <div className="row">
                <div className="col" style={{textAlign: "right"}}>
                    <p>
                      <strong>Gesamtrückzahlung</strong>
                  </p>
              </div>
              <div className="col" style={{textAlign: "left"}}>
                  <p>
                      <small>{formatEuroNumber(rueckges)} €</small>
                    </p>
                </div>
            </div>

            <div className="row text-center">
                <hr style={{width: "500px", margin: "auto", paddingRight: "120px"}} />
            </div>
        </div>
        </div>
        </div>
  );
};

export default RepresentativeCase;
